import { ProcedureStatus } from '../enums';

/**
 * Get all statuses pertaining to Skipped Procedures
 */
const getSkipProcedureStatusTypes = () => [ProcedureStatus.SKIPPED, ProcedureStatus.ICF_SKIPPED, ProcedureStatus.PERMANENT_SKIPPED];

// eslint-disable-next-line import/prefer-default-export
export { getSkipProcedureStatusTypes };
